module.exports = __webpack_public_path__ + "static/img/3.8249410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/3.png
// module id = V6JR
// module chunks = 1